import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { TableSettings } from './TableSettings';
import { TableColumn } from './TableColumn';
import { cloneDeep } from '@apollo/client/utilities';

export class TableSettingsInput extends TableSettings<any> implements EntityInput<TableSettings<any>> {
  constructor(obj: any) {
    super(obj);
  }

  forCreate(): CreateTableSettingsInput {
    return CreateTableSettingsInput.from(this, CreateTableSettingsInput);
  }

  forUpdate(): UpdateTableSettingsInput {
    return UpdateTableSettingsInput.from(this, UpdateTableSettingsInput);
  }

  forDelete(): DeleteTableSettingsInput {
    return DeleteTableSettingsInput.from(this, DeleteTableSettingsInput);
  }

  withColumns(columns: TableColumn<any>[]) {
    this.columns = columns.map((i, idx) => ({ column: i.column, label: i.label, index: idx }));
    return cloneDeep(this);
  }

  hasChanges(original: TableColumn<any>[] | undefined): boolean {
    if (!original) return true;
    if (original.length !== this.columns.length) return true;

    for (let i = 0; i < this.columns.length; i++) {
      const col = original[i];
      const item = this.columns[i];

      if (col.column !== item.column || col.label !== item.label || col.index !== item.index) return true;
    }
    return false;
  }
}

export class CreateTableSettingsInput extends forCreate(TableSettingsInput) {}

export class UpdateTableSettingsInput extends forUpdate(TableSettingsInput) {}

export class DeleteTableSettingsInput extends forDelete(TableSettingsInput) {}
